<div
  class="u-borderBottom-grey100"
  mat-dialog-title
  i18n="@@eventsView.submissionAnswerDialog.title"
>
  Registration question
</div>
<mat-dialog-content class="u-borderBottom-grey100">
  @if (data.isPathwayPreferences) {
    <p
      class="u-textDecoration-bold text-heading-lg u-paddingTop-16 color-black"
    >
      {{ data.opportunity.title }}
    </p>
    <p
      [nzEllipsisRows]="2"
      class="color-text-subdued text-body-md u-paddingTop-xsmall"
      nz-typography
      nzEllipsis
    >
      {{ data.opportunity.description }}
    </p>
  }
  <div class="u-padding-small-0">
    <b class="text-body-lg color-black">
      <span class="color-critical">*</span>
      {{ data.opportunity.submission_instructions[0] }}
    </b>
  </div>
  <mat-form-field class="u-width-100">
    <textarea
      i18n-placeholder="
        @@eventsView.submissionInstructionsDialog.answerPlaceholder"
      [cdkAutosizeMinRows]="2"
      [formControl]="form"
      [ngStyle]="{ resize: 'none' }"
      cdkTextareaAutosize
      class="u-display-block"
      matInput
      placeholder="Type your answer here"
    >
    </textarea>
  </mat-form-field>
  <p
    class="text-color-default text-body-md"
    i18n="@@eventsView.submissionInstructionsDialog.userWarning"
  >
    Your response will only be shared with the host to create the event agenda.
  </p>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button
    i18n="@@global.cancel"
    [typedDialog]="dialogRef"
    mat-button
    mat-dialog-close
  >
    Cancel
  </button>
  <button
    i18n="@@global.submit"
    [disabled]="!form.value"
    [mat-dialog-close]="{ event: data.opportunity, submission: form.value }"
    [typedDialog]="dialogRef"
    color="primary"
    mat-button
  >
    Submit
  </button>
</mat-dialog-actions>
